import { JSX, useEffect, useState } from "react";
import {
    Button,
    LinearProgress,
} from '@mui/material';
import {
    AddCircleOutline
} from '@mui/icons-material';
import { Coupon } from "../../../../../types/entities";
import {
    useGetMany
} from 'react-admin';
import { SubscriptionManagerDiscountPanelModal } from "./SubscriptionManagerDiscountPanelModal";

export const SubscriptionManagerDiscountPanel: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const [activeCoupons, setActiveCoupons] = useState<string[]>(props?.activeDiscounts);
    const { data, isPending, error, refetch } = useGetMany(
        'coupons',
        { ids:  activeCoupons }
    );

    useEffect( (): void => {
        setActiveCoupons(props?.activeDiscounts);
    }, [ props?.activeDiscounts] );

    return (
        <>
            <div className="discount__container">
                <div className="container__view">
                    { (isPending) &&
                        <div className="view__loader">
                            <LinearProgress sx={ { height: '40px', width: '100%' } } />
                        </div>
                    }
                    { (!isPending && data && data.length <= 0) &&
                        <div className="view__empty">
                            <span>{ "No active discounts" }</span>
                        </div>
                    }
                    { (!isPending && data && data.length > 0) &&
                        <>
                            { data?.map((discount: Coupon, index: number): JSX.Element => {
                                return (
                                    <div className="view__item" key={ discount.id + "_discount_item_" + index }>
                                        <span>{ discount.name }</span>
                                    </div>
                                );
                            } ) }
                        </>
                    }
                </div>
                <div className="container__button">
                    <SubscriptionManagerDiscountPanelModal
                        handleDiscountChange={ props.handleActiveDiscountChange }
                        activeDiscounts={ activeCoupons }
                    />
                </div>
            </div>
        </>
    );
}